<template>
  <FlareImage />
</template>

<script setup lang="ts">
  import { resolveDirective } from 'vue'

  interface FlareOptions {
    size?: FlareSize
    width?: String | Number
    height?: String | Number
    aspectRatio?: String | Number
    crop?: FlareCrop
    backgroundColor?: String
    gravity?: FlareGravity
    zoom?: String | Number
    format?: FlareFormat
    quality?: String | Number
    radius?: String | Number
  }

  interface FlareProps extends FlareOptions {
    lazy?: Boolean | String
    dataNotLazy?: Boolean | String
    src?: FlareImage
    srcset?: FlareImage
    alt?: String,
    requestLarger?: Boolean,
    class?: Boolean
  }
  
  const props = withDefaults(defineProps<FlareProps>(), {
    lazy: () => true,
    dataNotLazy: () => false,
    alt: () => '',
    quality: () => 90,
    requestLarger: () => true,
    format: 'auto',
    size: 'width'
  })

  const isLazy = !(props.lazy === false || props.dataNotLazy !== false)
  const directives: Array<any> = isLazy ? [[resolveDirective('lazy-load')]] : []

  const attrs = computed(() => {
    const attr = {
      src: isLazy ? 'data-src' : 'src',
      srcset: isLazy ? 'data-srcset' : 'srcset'
    }

    const multiplier = props.requestLarger ? 1.33 : 1

    const calculatedAttrs: any = {
      width: Math.floor(Number(props.width) * multiplier),
      height: Math.floor(Number(props.height) * multiplier),
    }

    const attrs = {
      width: props.size !== 'both' ? (props.src || props.srcset)?.meta?.width : calculatedAttrs.width,
      height: props.size !== 'both' ? (props.src || props.srcset)?.meta?.height : calculatedAttrs.height,
      alt: props.alt?.alt ?? props.alt ?? ''
    } as any

    if (props.class) attrs.class = props.class

    if (props.srcset) attrs[attr.srcset] = getSrcset(props.srcset, getFlareOptions({...props, ...calculatedAttrs }))
    else attrs[attr.src] = getFlareVersion(props.src, getFlareOptions({...props, ...calculatedAttrs }))

    return attrs
  })

  const FlareImage = () => withDirectives(h('img', attrs.value), directives)
</script>
